module.exports = __webpack_public_path__ + "img/download-hover.c218d93b.svg";